 <template>
  <v-container
    class="d-flex flex-column"
    fluid
  >
    <v-row  class="justify-center text-h5 text-md-h4 text-lg-h4 text-xl-h3 text-center font-weight-bold pa-7 ma-xl-12" >
        Tableau General Training
    </v-row>
    <v-row justify="center">
      <v-col sm="12" md="6" lg="4" xl="4">
        <v-card outlined style="border-color: white">
          <v-layout column align-center>
            <v-avatar size="120" style="border:3px solid #b2fce4 !important;">
              <v-icon size="70" color="black">
                mdi-account-outline
              </v-icon>
            </v-avatar>
            <v-btn href="https://www.tableau.com/learn/get-started/viewer" target="_blank"
                   outlined large rounded width="70%"
                   class="mt-5 text-h6 font-weight-bold"
                   style="background-color: #b2fce4; border-color: #b2fce4"
            >
              Viewer
            </v-btn>
            <v-card-text style="width: 80%">
              <div v-for="item in vieweritems" :key="item.name" class="text-subtitle-1">
                <v-icon >mdi-check</v-icon>
                {{item.name}}
              </div>
            </v-card-text>
            </v-layout>
        </v-card>
      </v-col>
      <v-col class="hidden-md-and-down" cols="2" align-self="center">
        <v-layout column align-center>
          <v-img width="50%" :src="require('../assets/Afterpay sticker black on mint no bordersmall.png')">
          </v-img>
        </v-layout>
      </v-col>
      <v-col sm="12" md="6" lg="4" xl="4">
        <v-card outlined style="border-color: white">
          <v-layout column align-center >
            <v-avatar size="120" style="border:3px solid #b2fce4  !important;">
              <v-icon size="70" color="black">
                mdi-account-cog-outline
              </v-icon>
            </v-avatar>
            <v-btn href="https://www.tableau.com/learn/get-started/creator" target="_blank"
                   outlined large rounded width="70%"
                   class="mt-5 text-h6 font-weight-bold"
                   style="background-color: #b2fce4; border-color: #b2fce4"
            >
              Creator
            </v-btn>
            <v-card-text style="width: 80%">
              <div v-for="item in creatoritems" :key="item.name" class="text-subtitle-1">
                <v-icon >mdi-check</v-icon>
                {{item.name}}
              </div>
            </v-card-text>
            </v-layout>
        </v-card>
      </v-col>
    </v-row>
    <v-divider/>
    <v-row  class="justify-center text-h6 text-md-h5 text-lg-h5 text-xl-h4 text-center font-weight-bold pt-7 pb-3" >
        Available Resources
    </v-row>
    <v-row>
      <v-col sm="12" md="6" lg="4" xl="4" v-for="module in Wholeitems" :key="module.modulename">
        <v-card outlined rounded color="rgba(0,0,0,0.03)" >
          <div class="d-flex justify-space-around">
            <v-layout class="column align-center justify-center">
              <v-avatar>
                 <v-img :src="module.imagepath">
                 </v-img>
                </v-avatar>
              <v-card-title class="text-subtitle-1">
                {{ module.modulename }}
              </v-card-title>
            </v-layout>
            <v-layout v-if="module.itemcount===3" column justify-center justify-space-around>
               <div v-for="item in module.resourceitems" :key="item.name" class="text-subtitle-1 pa-5">
                 <v-btn outlined large rounded block :href="item.link" target="_blank" class="text-capitalize text-subtitle-1">
                {{item.name}}
                 </v-btn>
              </div>
            </v-layout>
            <v-layout v-else-if="module.itemcount===4" column justify-center justify-space-around>
               <div v-for="item in module.resourceitems" :key="item.name" class="text-subtitle-1 pa-2">
                 <v-btn outlined large rounded block :href="item.link" target="_blank" class="text-capitalize text-subtitle-1">
                {{item.name}}
                 </v-btn>
              </div>
            </v-layout>
          </div>
          <v-layout >
          </v-layout>
        </v-card>
      </v-col>

<!--      <v-col cols="3">-->
<!--        <v-card >-->
<!--            <v-layout d-flex column justify-center align-center>-->
<!--              <v-avatar >-->
<!--                 <v-img :src="require('../assets/tableau.png')">-->
<!--                 </v-img>-->
<!--                </v-avatar>-->
<!--              <v-card-title class="text-subtitle-1">-->
<!--                Tableau Website-->
<!--              </v-card-title>-->
<!--            </v-layout>-->
<!--               <div v-for="item in tableauitems" :key="item.name" class="my-5">-->
<!--                 <v-btn outlined large rounded block :href="item.link" target="_blank" class="text-capitalize text-subtitle-1">-->
<!--                {{item.name}}-->
<!--                 </v-btn>-->
<!--              </div>-->
<!--          <v-layout >-->
<!--          </v-layout>-->
<!--        </v-card>-->
<!--      </v-col>-->
    </v-row>
    <v-footer height="50px" padless color="white">
      <v-col
        class="text-center text-h6 "
      >
        For further question, contact <a v-bind:href="'mailto:' + email" class="text-decoration-underline" style="color:black; ">{{ email }}</a>
      </v-col>
    </v-footer>
    </v-container>
</template>
<script>
export default {
  name: "tutorial",
  data() {
    return {
      creatoritems: [
        {name: "Create and publish new workbook"},
        {name: "Create and run data flow"},
        {name: "Create subscriptions for others"}
      ],
      vieweritems: [
        {name: "Interact with dashboards"},
        {name: "Create and share custom views"},
        {name: "Download reports"}
      ],
      Wholeitems: [
        {
          modulename: "Tableau Website",
          imagepath: require('../assets/tableau.png'),
          resourceitems: [
            {name: "Free Training Videos", link: "https://www.tableau.com/learn/training/20203"},
            {name: "On-Demand Webinars", link: "https://www.tableau.com/learn/webinars"},
            {name: "Recorded Live Training", link: "https://www.tableau.com/learn/series/live-training"}
          ],
          itemcount:3
        },
        {
          modulename: "YouTube Tutorial",
          imagepath: require('../assets/yt_icon_rgb.png'),
          resourceitems: [
            {name: "Tableau Software", link: "https://www.youtube.com/user/tableausoftware"},
            {name: "Andy Kriebel", link: "https://www.youtube.com/playlist?list=PLX-uPHRG0cLZVuwKdK22A8aa-e0pp7l_S"},
            {name: "Data Coach", link: "https://www.youtube.com/playlist?list=PLXiiyKbIXaPHEVAudfBMwZi57-WFxA9dT"},
            {name:"Art of Visualization", link:"https://www.youtube.com/playlist?list=PLE50-dh6JzC450Hn6EjPM238yZUPs-RQ1"}
          ],
          itemcount:4
        },
        {
          modulename: "Great Blog",
          imagepath: require('../assets/Paper.png'),
          resourceitems: [
            {name: "Tableau Magic", link: "https://tableaumagic.com/"},
            {name: "Information Lab", link: "https://www.theinformationlab.co.uk/category/blog/"},
            {name: "Flerlage twins", link: "https://www.flerlagetwins.com/"}
          ],
          itemcount:3
        },
      ],
       email:this.$email
    }
  },
  methods:{
      openlink: function () {
        window.open("https://itsolutionstuff.com", "_blank");
      }

  }
}
</script>

<style scoped>

</style>
